export default __webpack_public_path__ + "static/media/gallery-wip-handle_00.05ffb6d0.jpg";